import { validateQuad } from "./qr-pose.js";
import { t as createDetectionScheduler } from "../../detection-scheduler-PSFJiKJq.js";
//#region ../src/ar/qr/qr-detection-controller.ts
/**
* Create the thin RAW producer. On each accepted decode it emits a
* {@link RawQrObservation} via `recordDetection`; it does not size or solve.
*/
function createQrDetectionController(deps) {
	const { detect, getProjectionMatrix, recordDetection, now, minIntervalMs = 0, requiredLockCount = 2, onStatus } = deps;
	let status = "idle";
	function setStatus(next) {
		if (status === next) return;
		status = next;
		onStatus?.(next);
	}
	async function runDetect(frame) {
		const { image, cameraPose } = frame;
		if (status === "idle") setStatus("scanning");
		const detection = await detect(image);
		if (!detection) return null;
		if (!validateQuad(detection.corners).ok) return null;
		const projectionMatrix = getProjectionMatrix();
		if (!projectionMatrix) return null;
		return {
			text: detection.text,
			corners: detection.corners,
			cameraPose,
			projectionMatrix,
			imageWidth: image.width,
			imageHeight: image.height,
			timestamp: frame.capturedAtMs,
			...detection.orderSource ? { orderSource: detection.orderSource } : {}
		};
	}
	const scheduler = createDetectionScheduler({
		detect: runDetect,
		minIntervalMs,
		requiredLockCount,
		...now ? { now } : {},
		onLocked: (observation) => {
			recordDetection(observation);
			setStatus("tracking");
		},
		onMiss: () => {
			if (status === "tracking") setStatus("scanning");
		}
	});
	return {
		offerFrame(frame) {
			scheduler.offerFrame(frame);
		},
		isBusy() {
			return scheduler.inFlight;
		},
		get status() {
			return status;
		},
		reset() {
			setStatus("idle");
		},
		dispose() {
			scheduler.dispose();
		}
	};
}
//#endregion
export { createQrDetectionController };
